import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../api/client';

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]     = useState(null);
  const [ready, setReady]   = useState(false);

  useEffect(() => {
    if (localStorage.getItem('access_token')) {
      authApi.me().then(({ data }) => setUser(data)).catch(() => localStorage.clear()).finally(() => setReady(true));
    } else { setReady(true); }
  }, []);

  const login = async (email, password) => {
    const { data } = await authApi.login(email, password);
    localStorage.setItem('access_token',  data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { localStorage.clear(); setUser(null); };

  const isSA         = user?.role === 'superadmin';
  const isAdmin      = user?.role === 'admin' || isSA;
  const mustChangePw = user?.must_change_password === true;

  return (
    <Ctx.Provider value={{ user, ready, login, logout, isSA, isAdmin, isField: user?.role === 'field', canDelete: isSA, canWrite: isAdmin, mustChangePw }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
